import { type LoaderFunctionArgs, redirect } from '@remix-run/node'
import { type MetaFunction, useLoaderData } from '@remix-run/react'
import { CarService } from '#app/entities/car/service.server.js'
import { carIsAvailable } from '#app/routes/_api+/api.car.availability.verify.$id.ts'
import { getCarSlugMetaTags } from '#app/shared/lib/meta-tags.ts'
import {
  isCarOlderThan6Years,
  invariantResponse,
} from '#app/shared/lib/misc.js'
import { Spacer } from '#app/shared/ui/data-display/Spacer.js'
import { redirectWithToast } from '#app/shared/ui/feedback/toast/toast.server.ts'
import Header from '#app/shared/ui/layout/Header.js'
import { MainContainer } from '#app/shared/ui/layout/MainContainer.js'
import CarSummary from './ui/carSummary'
import CarSummaryDrawerMobile from './ui/carSummaryDrawerMobile'
import ConfirmReservation from './ui/confirmReservation'

export async function loader({ params, request }: LoaderFunctionArgs) {
  const carSlug = params.carSlug
  const car = await CarService.findBySlug(carSlug!)
  invariantResponse(car, 'Car not found', {
    status: 404,
  })

  if (!carIsAvailable({ car })) {
    const isSold = car.reservation?.isPurchaseCompleted
    return redirectWithToast('/nuestros-coches', {
      description: isSold
        ? 'Lo sentimos, el coche ya ha sido vendido'
        : 'Lo sentimos, el coche ya ha sido reservado',
    })
  }

  if (isCarOlderThan6Years(car)) {
    return redirect(`/coche/${carSlug}/reservar?typeOfPayment=Al%20contado`)
  }

  return { carSlug, car, domainUrl: new URL(request.url).origin }
}

export const meta: MetaFunction<typeof loader> = ({ matches, data }) => {
  return getCarSlugMetaTags({
    car: data?.car as any,
    domainUrl: data?.domainUrl,
    matches,
    index: false,
  })
}

export default function Index() {
  const { carSlug, car } = useLoaderData<typeof loader>()
  const showBanner = true
  return (
    <>
      {/* HEADER */}
      <Header isSticky={true} showBanner={showBanner} />
      <CarSummaryDrawerMobile car={car as any} showBanner={showBanner} />
      <div className="bg-neutral-25">
        <Spacer size="20px" />
        <MainContainer
          className={`
            flex flex-col gap-4 px-4

            lg:flex-row
          `}
        >
          <ConfirmReservation carSlug={carSlug as any} />
          <div
            className={`
              hidden

              lg:block
            `}
          >
            <CarSummary car={car as any} />
          </div>
        </MainContainer>
        <Spacer size="64px" />
        <Spacer size="56px" />
      </div>
    </>
  )
}
